module.exports = __webpack_public_path__ + "img/logo-mini-blue.67879b51.png";